import { useState, useEffect } from 'react';
import styled, { css, keyframes } from 'styled-components';
import { Container, Row, Col } from 'react-bootstrap';
import { Button } from 'antd';
import Logo from '../../assets/img/axiona-logo.png';
import MenuIcon from '../../assets/icons/menu.png';
import MxFlag from '../../assets/img/mx-flag.jpg';
import UsFlag from '../../assets/img/us-flag.jpg';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useTranslation } from 'react-i18next';
//import { Menu as NavDrawer } from './drawer';


const HeaderContainer = styled.div`
    background-color: #003A5D;
    box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.25);
    height: 80px;
    display: flex;
    justify-content: flex-end !important;
    vertical-align: middle;
    padding: 15px 0px;
    width: 100%;
    @media only screen and (min-width: 992px) {
      margin-bottom: 70px;
    } 
    @media only screen and (max-width: 768px) {
      height: 70px;
      padding-top: 15px;
      padding-bottom: 15px;
    }
`;

const LogoImg = styled.img`
    height: 45px;
    @media only screen and (max-width: 768px) {
        max-height: 40px;
    }
`;

const StyledLink = styled(Link)`
  > p {
    font-size: 15px;
    font-family: IBM Plex Sans;
    font-weight: 500;
    text-decoration: none;
    color: #FFFFFF;
    margin: 0;
  }
    &.active p {
    color: #fff;
    font-weight: bold;
    line-height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 91px;
    height: 43px;
    background: #EAAC34;
    border-radius: 35px;
    border: none;
  }
  :hover {
    background: #1379BC;
    color: #fff;
    font-weight: bold;
    line-height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 91px;
    height: 43px;
    border-radius: 35px;
  }
    
`;

const StyledSection = styled.a`
  > p {
    font-size: 15px;
    font-family: IBM Plex Sans;
    font-weight: 500;
    text-decoration: none;
    color: #FFFFFF;
    margin: 0;
    padding: 0;
  }
`;

const TestsButton = styled.button`
  font-family: 'IBM Plex Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 20px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  color: #FFFFFF;
  width: 91px;
  height: 43px;
  background: ${props => props.showTests ? '#EAAC34' : 'transparent'};
  border-radius: 35px;
  border: none;
  margin-right: 1rem;
  @media only screen and (max-width: 992px) {
    height: 27px;
  }
`;

const StyledDivTests = styled.div`
  padding: 5px 40px;
  width: 100%;
  background: #F2F7F7;
  position: absolute;
  left: 50%;
  div div {
    align-items: center;
  }
  #container-tests {
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
  }
  .col-8 {
    padding: 0 6px;
  }
  margin-left: auto;
  margin-right: auto;
  visibility: ${props => props.show === 1 ? 'hidden' : 'visible'};
  transform: ${props => props.showmenu ? 'translate(-50%,0)' : 'translate(-50%, -125px)'};
  transition: all 300ms;
  transition-delay: 50ms;
  .opened {
    border-radius: 10px;
    background: rgba(19, 121, 188, 0.15);
    @media only screen and (max-width: 992px) {
      padding: 0 4px;
    }
  }
  @media only screen and (min-width: 992px) {
    margin-top: -70px;
  } 
  @media only screen and (max-width: 992px) {
    border-radius: 0px 0px 15px 15px;
    left: auto;
    right: 0;
    width: 200px;
    padding: 6px 6px;
    transform: ${props => props.showmenu ? 'translate(0, 0);' : 'translate(0, -355px) !important'};
    transition: all 600ms;
    .col-12 {
      padding: 0;
    }
    hr {
      margin: 6px 0;
    }
  }
  text-align: left;
  span {
    font-weight: 700;
    color: #000;
  }
  img {
    width: 60px;
  }
  #heme-img {
    width: 60px;
  }
  .col-lg-3 {
    display: flex;
    align-items: center;
    padding-left: 6px;
    padding-right: 2px;
    @media only screen and (max-width: 992px) {
      padding: 0;
    }
  }
  .test {
    cursor: pointer;

  }
  #second {
    @media only screen and (min-width: 992px) {
      border-left: 1.5px solid #1379BC;
      border-right: 1.5px solid #1379BC;
    }
  }
  #third {
    @media only screen and (min-width: 992px) {
      border-right: 1.5px solid #1379BC;
    }
  }
  #links-div {
    display: flex !important;
    flex-direction: column;
    a {
      text-align: center;
      font-family: 'IBM Plex Sans';
      font-style: normal;
      font-weight: 400;
      font-size: 15px;
      line-height: 20px;
      color: #1C3245;
      margin 9px 0;
      span {
        font-weight: 700;
      }
    }
  }
`;

const TopWhite = styled.div`
  width: 100%;
  height: 40px;
  background: #E0EDF5;
  .container {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
  }
  a {
    font-family: 'IBM Plex Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 17px;
    line-height: 26px;
    color: #1C3245;
    margin-bottom: 0;
  }
  img {
    width: 18px;
  }
`;

const NavImage = styled.img`
  max-width: 2em;
  max-height: 2em;
  @media only screen and (max-width: 768px) {
    max-width: 25px;
  }
  :hover {
    transform: scale(1.1, 1.1);
  }
`;

const BurguerButton = styled(Button)`
  display: flex;
  align-items: center;
`;

const RowItemTest = styled(Row)`
  transition: transform 0.3s;

  ${(props) =>
    props.bigger &&
    css`
      transform: scale(1.08);
    `}
`;

const animate = keyframes`
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
`;

const AnimatedItem = styled(RowItemTest)`
  @media only screen and (min-width: 768px) {
    animation: ${({ anima }) =>
      !anima
        ? 'none'
        : css`
            ${animate} 3s infinite
          `};
  }
`;

const SelectLng = styled.select`
  padding: 2px 10px;
  border-radius: 5px;
  border: none;
  appearance: none;
  cursor: pointer;
  &:hover {
    border: none;
  };
  &:focus {
    outline: none;
  }
`;

const LangFlag = styled.div`
  width: 25px;
`;

const FlagImg = styled.img`
  width: 25px !important;
  height: 100%;
`;

export const NavBar = () => {
  const [width, setWidth] = useState(window.innerWidth);
  const [showTests, setShowTests] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  let isMobile = width <= 992;
  const {pathname, hash} = useLocation();
  const location = useLocation();
  const [activeButton, setActiveButton] = useState('');

  const [t, i18n] = useTranslation('global');
  const [lang, setLang] = useState('es');
  
  // For navbar testitems
  const [biggerItems, setBiggerItems] = useState(false);

  document.addEventListener('click', function (event) {
    if (event.target.id !== 'tests-menu' && event.target.id !== 'tests-menu-button') {
      setShowTests(false);
    }
  });

  document.addEventListener('click', function (event) {
    if (event.target.id !== 'menu-div' && event.target.id !== 'menu-div-button') {
      setShowMenu(false);
    }
  });


  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  const changeLanguage = (event) => {
    i18n.changeLanguage(event.target.value);
    setLang(event.target.value);
  };

  useEffect(()=> {
    if (hash === '#contacto') {
      const element = document.getElementById(hash.substring(1));
      if (element) {
        setTimeout(() => element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" }), 100);
      }
    } else {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }

    window.addEventListener('resize', handleWindowSizeChange);
    return () => window.removeEventListener('resize', handleWindowSizeChange);
  }, [hash]);



  return (
    <>
    <div style={{width: "100%", position: "-webkit-sticky", position: "sticky", top: "0", zIndex: "101"}}>
    <TopWhite>
      <Container>
        <a href={"tel:+525519694584"}>
          <img alt='phone' src='https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2Fnavbar%2Fphone.png?alt=media&token=a3a9c2a1-b928-48d6-9cc9-f6483bbc0fb6'/>
          &nbsp;&nbsp;&nbsp;{!isMobile && t("footer.line")} +52 55 19 69 4584
        </a>
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '150px'}}>
          {isMobile &&
            <TestsButton showTests={showTests} onClick={()=>setShowTests(true)} id="tests-menu-button">{t('nav-bar.tests')}</TestsButton>
          }
          <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', width: '100px', height: '100%'}}>
            <LangFlag>
              <FlagImg alt='flag' src={lang === 'es' ? MxFlag  : UsFlag }/>
            </LangFlag>
            <SelectLng id='lang' onChange={changeLanguage}>
              <option value='es'>Español</option>
              <option value='en'>English</option>
            </SelectLng>
          </div>
        </div>
      </Container>
    </TopWhite>
    <HeaderContainer>
      <Container>
        <Row className='align-items-center'>
          <Col xs={5} lg={3} xl={4}>
            <div className='d-flex'>
              <Link to='/'>
                <LogoImg alt="Axiona Web Logo" className='img-fluid' src={Logo} />
              </Link>
            </div>
          </Col>
          <Col xs={7} lg={9} xl={8}>
            <Row className='justify-content-end'>
              {
                isMobile ? (
                  <></>
                ) : (
                  <Col xs={12}>
                    <div className='d-flex flex-row justify-content-around align-items-center'>
                      <StyledLink to='/' className={location.pathname === '/' ? 'active' : ''}>
                        <p>{t('nav-bar.home')}</p>
                      </StyledLink>
                      <TestsButton showTests={showTests} onClick={()=>{setShowTests(!showTests); setActiveButton('tests');}} onMouseEnter={()=>setBiggerItems(true)} onMouseLeave={()=>setBiggerItems(false)} id="tests-menu-button" className={location.pathname.includes('axiona') ? 'active' : ''}>{t('nav-bar.tests')}</TestsButton>
                      {/* <StyledDdButton align={"start"} title="Pruebas">
                        <StyledDropdown.Item eventKey="1" as={StyledLink} to='/axionasolid'>Axiona Solid</StyledDropdown.Item>
                        <StyledDropdown.Item eventKey="2" as={StyledLink} to='/axionagene'>Axiona Gene</StyledDropdown.Item>
                        <StyledDropdown.Item eventKey="3" as={StyledLink} to='/axionaheme'>Axiona Heme</StyledDropdown.Item>
                      </StyledDdButton> */}
                      <StyledLink to='/pacientes' className={location.pathname === '/pacientes' ? 'active' : ''}>
                        <p>{t('nav-bar.patients')}</p>
                      </StyledLink>
                      <StyledLink to='/medicos' className={location.pathname === '/medicos' ? 'active' : ''}>
                        <p>{t('nav-bar.doctors')}</p>
                      </StyledLink>
                      <StyledLink to={{pathname: '/', hash: '#contacto'}} >
                        <p>{t('nav-bar.contact')}</p>
                      </StyledLink>
                      <StyledSection target='_blank' href='https://solicitudes.axionagenetics.com/'>
                        <p>{t('nav-bar.generate-request')}</p>
                      </StyledSection>
                      {/* <StyledLink to='/report'>
                        <p>Reporte</p>
                      </StyledLink>
                      <StyledLink to='/patients'>
                        <p>Pacientes</p>
                      </StyledLink>
                      <StyledLink to='/doctors'>
                        <p>Médicos</p>
                      </StyledLink> */}
                      {/* <StyledLink to='/aboutus'>
                        <p>Nosotros</p>
                      </StyledLink> */}
                    </div>
                  </Col>
                )
              }
              <Col xs={12} sm={12} lg={4} className='d-flex justify-content-end'>
                {/* <StyledLink to='/' className='d-flex flex-row align-items-center'
                  style={{marginRight: '.8rem'}}>
                  <p style={{marginRight: '.8rem'}}>LogIn</p>
                  <img alt='login' src={LoginIcon} style={{maxWidth: '2em', maxHeight: '2em'}} />
                </StyledLink> */}
                {/* <LangButton>
                  <LangImg onClick={changeLanguageButton} src={ t('home.therapy.info-highlight') === "Targeted" ? usFlag : mxFlag } alt="flag"/> 
                </LangButton> */}
                {/* <SelectLng id='lang' onChange={changeLanguage}>
                  <option value='es'>Español</option>
                  <option value='en'>English</option>
                </SelectLng> */}
                {/* {isMobile ? (
                  <NavDrawer />
                  ) : (
                    <>
                    </>
                )} */}
              </Col>
              {isMobile ? (
                <Col xs={12} sm={12} lg={4} className='d-flex justify-content-end'>
                  <BurguerButton
                    style={{ border: 'none' }}
                    type='ghost'
                    onClick={()=>setShowMenu(true)}
                    id="menu-div-button"
                  >
                    <NavImage src={MenuIcon} alt='Menu' id="menu-div-button"/>
                  </BurguerButton>
                </Col>
                // <Col xs={12} sm={12} lg={4} className='d-flex justify-content-end'>
                //   <NavDrawer />
                // </Col>
                ) : (
                  <>
                  </>
              )}
            </Row>
          </Col>
        </Row>
      </Container>
    </HeaderContainer>
    </div>
    <div style={{position: 'fixed', width: '100%', zIndex: '100'}}>
      <div style={{position: 'relative', width: '100%', zIndex: '100'}}>
        <StyledDivTests showmenu={!isMobile ? showTests : true} show={!(isMobile ? showTests : true) ? 1 : 0} id="tests-menu">
          <div id='container-tests'>
            <Row>
              <Col xs={12} lg={3}>
                <Link to='/axionasolid'>
                  <AnimatedItem className={`item-bigger test ${pathname.includes('axionasolid') ? 'opened' : ''}`} bigger={biggerItems} anima={showTests}>
                    <Col xs={4} className="d-flex justify-content-center">
                      <img alt='Axiona solid' src='https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2FaxionaHome%2Fimg%2Fa_solid.png?alt=media&token=a61d7cfc-4eea-4f35-9a11-0b7548b4d583'/>
                    </Col>
                    <Col xs={8}>
                      <span>Axiona®</span> <span style={{fontWeight:"400"}}>SOLID</span>
                    </Col>
                  </AnimatedItem>
                </Link>
              </Col>
              {isMobile && <hr/>}
              <Col xs={12} lg={3} id="second">
                <Link to='/axionagene'>
                  <AnimatedItem className={`item-bigger test ${pathname.includes('axionagene') ? 'opened' : ''}`}  bigger={biggerItems} anima={showTests}>
                    <Col xs={4} className="d-flex justify-content-center">
                      <img alt='Axiona gene' src='https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2FaxionaHome%2Fimg%2Fa_gene.png?alt=media&token=b579dcb6-21b1-48ef-9ac0-9cb48445e253'/>
                    </Col>
                    <Col xs={8}>
                      <span>Axiona®</span> <span style={{fontWeight:"400"}}>GENE</span>
                    </Col>
                  </AnimatedItem>
                </Link>
              </Col>
              {isMobile && <hr/>}
              <Col xs={12} lg={3} id="third">
                <Link to='/axionaheme'>
                  <AnimatedItem className={`item-bigger test w100 ${pathname.includes('axionaheme') ? 'opened' : ''}`}  bigger={biggerItems} anima={showTests}>
                    <Col xs={4} className="d-flex justify-content-center">
                      <img id="heme-img" alt='Axiona heme' src='https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2FaxionaHome%2Fimg%2Fa_heme.png?alt=media&token=08da0b15-ab76-48bf-baeb-6d4622907ad8'/>
                    </Col>
                    <Col xs={8}>
                      <span>Axiona®</span> <span style={{fontWeight:"400"}}>HEME</span>
                    </Col>
                  </AnimatedItem>
                </Link>
              </Col>
              {isMobile && <hr/>}
              <Col xs={12} lg={3}>
              <Link to='/axionaliquid'>
                <AnimatedItem className={`item-bigger test w100 ${pathname.includes('axionaliquid') ? 'opened' : ''}`}  bigger={biggerItems} anima={showTests}>
                  <Col xs={4} className="d-flex justify-content-center">
                    <img id="heme-img" alt='Axiona liquid' src='https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2FaxionaHome%2Fimg%2Fa_liquid.png?alt=media&token=b8b76079-9fc2-47ab-9d16-56ca48a31ba9'/>
                  </Col>
                  <Col xs={8}>
                    <span>Axiona®</span> <span style={{fontWeight:"400"}}>LIQUID</span>
                  </Col>
                </AnimatedItem>
              </Link>
              </Col>
            </Row>
          </div>
        </StyledDivTests>
      </div>
    </div>
    <div style={{position: 'fixed', width: '100%', zIndex: '100'}}>
      <Container style={{position: 'relative', width: '100%', zIndex: '100'}}>
        <StyledDivTests showmenu={showMenu} show={!showMenu ? 1 : 0} id="menu-div">
          <div id="links-div">
            <Link to='/'>{t('nav-bar.home')}</Link>
            <p
              id="tests-menu-button"
              onClick={()=>setShowTests(true)}
              style={{textAlign: 'center', margin: '9px 0', fontWeight: '700'}}
            >{t('nav-bar.tests')}</p>
            {/* <Link to='/axionasolid'><span>Axiona®</span> SOLID</Link>
            <Link to='/axionagene'><span>Axiona®</span> GENE</Link>
            <Link to='/axionaheme'><span>Axiona®</span> HEME</Link>
            <Link to='/axionaliquid'><span>Axiona®</span> LIQUID</Link> */}
            <Link to='/pacientes'>{t('nav-bar.patients')}</Link>
            <Link to='/medicos'>{t('nav-bar.doctors')}</Link>
            <Link to='/#contacto' >
              {t('nav-bar.contact')}
            </Link>
            <a style={{fontWeight: '700'}} target='_blank' rel='noreferrer' href='https://solicitudes.axionagenetics.com/'>{t('nav-bar.generate-request')}</a>
          </div>
        </StyledDivTests>
      </Container>
    </div>

    </>
  );
};